import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { PaginatePickingsLogActions } from "store/ducks/pickings";

export function* paginatePickingsLogRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/pickings-logs?${queryString}`);

    const { pickings, pagination } = data;
    yield put(PaginatePickingsLogActions.success(pickings, pagination));
    if (onSuccess) onSuccess({ pickings, pagination });
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginatePickingsLogActions.failure(errorMessage));
  }
}
